import { PricingTier } from '@/pages/unauthenticated/pricing/components/types';
import { cn } from '@/lib/utils';

export const TierCardBorders = ({ tiers }: { tiers: PricingTier[] }) => {
  return (
    <div
      className="pointer-events-none absolute inset-x-8 inset-y-0 grid grid-cols-4 gap-x-8 before:block"
      aria-hidden="true"
    >
      {tiers.map((tier) => (
        <div
          key={tier.activeTier}
          className={cn('rounded-lg ring-1 ring-halfmast-900/10', {
            'ring-2 ring-primary': tier.featured,
          })}
        />
      ))}
    </div>
  );
};
